<template>
  <div class="about">
    <!-- Hero Section -->
    <section class="bg-bleumarine text-white py-16">
      <div class="container mx-auto px-4">
        <h1 class="text-3xl md:text-4xl font-bold text-center mb-4">À Propos de TechsPartner</h1>
        <p class="text-center text-turquoise max-w-2xl mx-auto">
          Découvrez notre histoire, notre mission et notre vision pour la transformation digitale en Afrique subsaharienne.
        </p>
      </div>
    </section>

    <!-- History Section -->
    <section class="py-16 bg-white">
      <div class="container mx-auto px-4">
        <div class="max-w-4xl mx-auto">
          <h2 class="section-title">Présentation de TechsPartner</h2>
          <div class="prose prose-lg text-gray-700">
            <p class="mb-4">
              TechsPartner est une entreprise spécialisée dans la conception, l'implémentation et l'administration de systèmes d'information.
            </p>
            <p class="mb-4">
              Elle est constituée d'un consortium d'experts en informatique, qui couvre toute la pluralité des domaines de l'informatique, dont :
            </p>
            <ul class="list-disc pl-6 mb-4 space-y-2">
              <li>l'infrastructure système et la productivité de l'entreprise</li>
              <li>les réseaux informatiques et télécommunications</li>
              <li>La fourniture de matériels informatiques</li>
              <li>La fourniture de solution de sécurité électronique</li>
              <li>le génie logiciel, les bases de données</li>
              <li>les services de consulting et d'ingénierie</li>
            </ul>
            <p class="mb-4">
              TechsPartner est une société de droit ivoirien qui s'est donnée pour mission d'accompagner les entreprises et les institutions des secteurs privé, public et parapublic, dans l'édification et la gestion proactive de leur système d'informations. Sa zone de couverture s'étend sur toute l'Afrique Subsaharienne.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Mission & Vision -->
    <section class="py-16 bg-gray-50">
      <div class="container mx-auto px-4">
        <div class="max-w-4xl mx-auto">
          <h2 class="section-title text-center">Notre Mission & Notre Vision</h2>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
            <div class="card">
              <div class="w-12 h-12 bg-turquoise rounded-lg flex items-center justify-center mb-4">
                <Target class="w-6 h-6" style="color: #fff;" />
              </div>
              <h3 class="text-xl font-semibold mb-3">Notre Mission</h3>
              <p class="text-gray-600">
                Accompagner les entreprises et institutions d'Afrique subsaharienne dans leur transformation digitale en fournissant des solutions innovantes, sécurisées et adaptées à leurs besoins spécifiques.
              </p>
            </div>
            <div class="card">
              <div class="w-12 h-12 bg-violet rounded-lg flex items-center justify-center mb-4">
                <Eye class="w-6 h-6" style="color: #fff;" />
              </div>
              <h3 class="text-xl font-semibold mb-3">Notre Vision</h3>
              <p class="text-gray-600">
                Devenir la référence digitale en Afrique subsaharienne en contribuant au développement technologique de la région et à l'émergence d'écosystèmes numériques performants.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Coverage Zone -->
    <section class="py-16 bg-white">
      <div class="container mx-auto px-4">
        <h2 class="section-title text-center">Zone de Couverture</h2>
        <p class="text-center text-gray-600 max-w-2xl mx-auto mb-8">
          Nous opérons principalement en Afrique subsaharienne avec une présence forte en Afrique de l'Ouest.
        </p>
        <div class="max-w-4xl mx-auto">
          <div class="bg-gray-100 rounded-lg p-8">
            <h3 class="text-xl font-semibold mb-4 text-bleumarine">Pays Couverts</h3>
            <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div class="flex items-center">
                <span class="w-2 h-2 bg-bleumarine rounded-full mr-2"></span>
                <span class="text-gray-700">Côte d'Ivoire</span>
              </div>
              <div class="flex items-center">
                <span class="w-2 h-2 bg-turquoise rounded-full mr-2"></span>
                <span class="text-gray-700">Sénégal</span>
              </div>
              <div class="flex items-center">
                <span class="w-2 h-2 bg-violet rounded-full mr-2"></span>
                <span class="text-gray-700">Mali</span>
              </div>
              <div class="flex items-center">
                <span class="w-2 h-2 bg-bleumarine rounded-full mr-2"></span>
                <span class="text-gray-700">Burkina Faso</span>
              </div>
              <div class="flex items-center">
                <span class="w-2 h-2 bg-turquoise rounded-full mr-2"></span>
                <span class="text-gray-700">Ghana</span>
              </div>
              <div class="flex items-center">
                <span class="w-2 h-2 bg-violet rounded-full mr-2"></span>
                <span class="text-gray-700">Bénin</span>
              </div>
              <div class="flex items-center">
                <span class="w-2 h-2 bg-bleumarine rounded-full mr-2"></span>
                <span class="text-gray-700">Togo</span>
              </div>
              <div class="flex items-center">
                <span class="w-2 h-2 bg-turquoise rounded-full mr-2"></span>
                <span class="text-gray-700">Guinée</span>
              </div>
            </div>
            <p class="mt-6 text-sm text-gray-600">
              * Notre zone d'intervention s'étend également à d'autres pays d'Afrique subsaharienne sur demande.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Team Section -->
    <!-- <section class="py-16 bg-gray-50">
      <div class="container mx-auto px-4">
        <h2 class="section-title text-center">Notre Équipe d'Experts</h2>
        <p class="text-center text-gray-600 max-w-2xl mx-auto mb-12">
          Une équipe pluridisciplinaire de professionnels certifiés passionnés par la technologie.
        </p>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          <div v-for="member in team" :key="member.name" class="card text-center">
            <div class="w-24 h-24 rounded-full mx-auto mb-4 flex items-center justify-center" :class="member.bgClass">
              <component :is="member.icon" class="w-12 h-12" style="color: #fff;" />
            </div>
            <h3 class="text-lg font-semibold">{{ member.name }}</h3>
            <p class="text-primary-600 text-sm mb-2">{{ member.role }}</p>
            <p class="text-gray-600 text-sm">{{ member.expertise }}</p>
          </div>
        </div>
      </div>
    </section> -->

    <!-- Values Section -->
    <section class="py-16 bg-white">
      <div class="container mx-auto px-4">
        <h2 class="section-title text-center">Nos Valeurs</h2>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto mt-8">
          <div class="text-center">
            <div class="w-16 h-16 bg-bleumarine rounded-full flex items-center justify-center mx-auto mb-4">
              <Lightbulb class="w-8 h-8" style="color: #fff;" />
            </div>
            <h3 class="text-lg font-semibold mb-2">Innovation</h3>
            <p class="text-gray-600 text-sm">
              Nous nous engageons à proposer des solutions innovantes et adaptées aux évolutions technologiques.
            </p>
          </div>
          <div class="text-center">
            <div class="w-16 h-16 bg-turquoise rounded-full flex items-center justify-center mx-auto mb-4">
              <Handshake class="w-8 h-8" style="color: #fff;" />
            </div>
            <h3 class="text-lg font-semibold mb-2">Partenariat</h3>
            <p class="text-gray-600 text-sm">
              Nous construisons des relations durables avec nos clients basées sur la confiance et la collaboration.
            </p>
          </div>
          <div class="text-center">
            <div class="w-16 h-16 bg-violet rounded-full flex items-center justify-center mx-auto mb-4">
              <CheckCircle class="w-8 h-8" style="color: #fff;" />
            </div>
            <h3 class="text-lg font-semibold mb-2">Excellence</h3>
            <p class="text-gray-600 text-sm">
              Nous visons l'excellence dans chaque projet en garantissant qualité et satisfaction client.
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { Target, Eye, Lightbulb, Handshake, CheckCircle } from 'lucide-vue-next'

// const team = ref([
//   {
//     name: 'Kouamé Jean',
//     role: 'Directeur Général',
//     expertise: 'Stratégie IT & Gestion',
//     icon: Briefcase,
//     bgClass: 'bg-bleumarine'
//   },
//   {
//     name: 'Touré Aminata',
//     role: 'Directrice Technique',
//     expertise: 'Architecture & Cloud',
//     icon: User,
//     bgClass: 'bg-turquoise'
//   },
//   {
//     name: 'Koffi Emmanuel',
//     role: 'Chef de Projet',
//     expertise: 'Gestion de Projets IT',
//     icon: User,
//     bgClass: 'bg-violet'
//   },
//   {
//     name: 'Diaby Fatou',
//     role: 'Responsable Sécurité',
//     expertise: 'Cybersécurité & Audit',
//     icon: Shield,
//     bgClass: 'bg-bleumarine'
//   }
// ])
</script>
